import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

export const VideoWrapper = styled.div`
  position: relative;
  cursor: ${({ theme }) => theme.cursor};
  width: 100%;
  max-width: ${({ theme }) => theme.maxWidth};
  height: auto;
  margin: 0 auto;
  padding: 0;
  border: ${({ theme }) => theme.border ?? 'none'};
  border-radius: ${({ theme }) => theme.borderRadius};
  overflow: hidden;
  box-shadow: ${({ theme }) => theme.shadow};
`;

export const Video = styled.video`
  display: block;
  width: 100%;
  max-width: ${({ theme }) => theme.maxWidth};
  height: auto;
`;

export const VideoControls = styled.div`
  display: flex;
  gap: 5px;
  align-items: center;
  position: absolute;
  bottom: 12px;
  left: 12px;
  width: calc(100% - 24px);
  height: 33px;
  padding: 4px 12px 4px 0;
  background-color: ${themeStyle.varBackgroundAlt};
  backdrop-filter: blur(81.5485px);
  border-radius: ${themeStyle.radiusMedium};
`;

export const PlayButton = styled.button`
  height: 100%;
  padding: 0;
  padding-left: 12px;
  background: transparent;
  border: none;
  cursor: pointer;

  svg {
    fill: ${themeStyle.varBrandMain};
    transform: rotate(90deg);
  }
`;

export const ProgressNumbers = styled.div`
  font-size: ${themeStyle.fontSize11};
  color: ${themeStyle.varInkMedium};
`;

export const ProgressBar = styled.input`
  width: 100%;
  height: 5px;
  -webkit-appearance: none; /* Hides the slider so that custom slider can be made */
  width: 100%; /* Specific width is required for Firefox. */
  background: transparent;
  margin: 0;

  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    border: none;
    height: 15px;
    width: 15px;
    border-radius: 50%;
    background: ${themeStyle.varBrandMain};
    cursor: pointer;
    margin-top: -5px;
  }

  &::-moz-range-thumb {
    -webkit-appearance: none;
    border: none;
    height: 15px;
    width: 15px;
    border-radius: 50%;
    background: ${themeStyle.varBrandMain};
    cursor: pointer;
  }

  &:focus {
    outline: none;
  }

  &::-webkit-slider-runnable-track {
    width: 100%;
    height: 5px;
    cursor: pointer;
    background: ${themeStyle.varInkLight};
    border-radius: 16px;
  }

  &:focus::-webkit-slider-runnable-track {
    background: ${themeStyle.varInkLight};
  }

  &::-moz-range-track {
    width: 100%;
    height: 5px;
    cursor: pointer;
    background: ${themeStyle.varInkLight};
    border-radius: 16px;
  }
`;

export const YoutubeIframe = styled.iframe`
  width: 888px;
  max-width: 100%;
  /* all Youtube embeds are shown as 16:9 ratio. this enforces responsive height on iframe */
  aspect-ratio: 16 / 9;
`;
